import { render, staticRenderFns } from "./GrassType.html?vue&type=template&id=35f897a6&scoped=true&external"
import script from "./GrassType.vue?vue&type=script&lang=js"
export * from "./GrassType.vue?vue&type=script&lang=js"
import style0 from "./GrassType.scss?vue&type=style&index=0&id=35f897a6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f897a6",
  null
  
)

export default component.exports